import { Component } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
}



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/app.component.ts